<ng-container *transloco="let t">
  <ld-base-modal [title]="title()" [showCloseButton]="false" (closeModal)="cancel.emit()">
    <div modal-content>
      <p
        id="loan-selection-modal-subtitle"
        class="text-base font-medium text-ld-neutral-500 leading-6 tracking-[0.16px] mb-6"
      >
        {{ subtitle() }}
      </p>

      <div id="loan-selection-modal-list" class="flex flex-col gap-6">
        @for (loan of loans(); track loan.loanNumber; let i = $index) {
          <button
            type="button"
            [id]="'loan-selection-card-' + i"
            class="loan-card flex gap-4 items-center p-6 rounded-3xl border border-ld-neutral-400 bg-white cursor-pointer transition-all hover:border-ld-primary hover:shadow-md focus:outline-none focus:ring-2 focus:ring-ld-primary focus:ring-offset-2"
            [class.selected]="isSelected(loan)"
            (click)="onLoanSelect(loan)"
          >
            <div [id]="'loan-selection-icon-' + i" class="shrink-0 size-8">
              <ld-svg-icon
                [src]="getLoanIcon(loan)"
                [attr.aria-label]="getLoanTypeShortName(loan) + ' icon'"
                class="size-full"
              />
            </div>

            <div [id]="'loan-selection-details-' + i" class="flex-1 flex flex-col gap-2 min-w-0">
              <div class="flex items-center justify-between w-full">
                <span
                  [id]="'loan-selection-type-' + i"
                  class="font-dm font-semibold text-xl leading-7 tracking-[0.4px]"
                  [class]="getLoanTypeColorClass(loan)"
                >
                  {{ getLoanTypeShortName(loan) }}
                </span>
                <span
                  [id]="'loan-selection-account-' + i"
                  class="font-medium text-base text-ld-neutral-700 leading-5 tracking-[0.32px] whitespace-nowrap uppercase"
                >
                  {{ getAccountDisplay(loan) }}
                </span>
              </div>

              <p
                [id]="'loan-selection-address-' + i"
                class="font-medium text-base text-ld-neutral-500 leading-6 tracking-[0.16px] text-left truncate"
              >
                {{ getAddressDisplay(loan) }}
              </p>
            </div>
          </button>
        }
      </div>
    </div>
  </ld-base-modal>
</ng-container>
